export default __webpack_public_path__ + "static/media/jim.d22f5567.png";